import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UniqueEntityID } from '@/domain/core'
import { UseCase } from '@/domain/core/UseCase'
import { UserChart } from '@/domain/models/UserChart'
import { Result } from '@/domain/protocols/Result'

import type { IUserChartRepository } from '@/data/UserChartRepository/IUserChartRepository'

export class LoadUserChartUseCase implements UseCase<UniqueEntityID, Promise<Result<UserChart>>> {
  private repository: IUserChartRepository

  constructor(repository?: IUserChartRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IUserChartRepository>(InjectionTokens.UserChartRepository)
  }

  async execute(chartId: UniqueEntityID): Promise<Result<UserChart>> {
    try {
      return await this.repository.getChart(chartId)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
